// removed by extract-text-webpack-plugin
module.exports = {"button":"src-components-Button__button--YTkrx"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Button.scss
// module id = 77
// module chunks = 0